module.exports = __webpack_public_path__ + "static/m4buya-c3eebe806061f3ef28605229bb536b25.png";